import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageService} from "../../../core/services/message.service";
import {Usuario} from "../../../models/usuario";
import {UsuarioService} from "../../../services/usuario.service";

@Component({
    selector: 'app-dialog-recusa-ativacao-usuario',
    templateUrl: './dialog-recusa-ativacao-usuario.component.html',
    styleUrls: ['./dialog-recusa-ativacao-usuario.component.scss']
})
export class DialogRecusaAtivacaoUsuarioComponent implements OnInit {

    public usuario: Usuario;
    public justificativa: string;

    public form: FormGroup;

    constructor(public dialogRef: MatDialogRef<DialogRecusaAtivacaoUsuarioComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private usuarioService: UsuarioService,
                private messageService: MessageService) {

    }

    ngOnInit() {
        this.dialogRef.disableClose = true;

        this.form = new FormGroup({
            justificativa: new FormControl(null, [
                Validators.required,
            ])
        });
    }

    close(salvar: boolean = false): void {
        this.dialogRef.close({salvar: salvar});
    }

    save(): void {

        if (this.form.valid) {
            let justificativa = this.form.get("justificativa").value ;
            let formData = new FormData();
            formData.append('cod_usuario', this.data.item)
            formData.append('justificativa', justificativa);
            this.usuarioService.msgUsuario(formData).subscribe(data => {
                this.close(true);
            });
        }


    }

}
